import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DbService } from 'src/app/services/db-service/db.service';
import { StudentManagementService } from '../../../es-sub-modules/student-management/student-management.service';
import { environment } from 'src/environments/environment';
import { HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-import-excel',
  templateUrl: './import-excel.component.html',
  styleUrls: ['./import-excel.component.scss']
})
export class ImportExcelComponent {
  selectedFile: File | null = null;
  isValidFile = false;
  isUploading = false;
  uploadProgress = 0;
  uploadComplete = false;
  uploadResult: any = null;
  isClass: boolean = false; 

  constructor(
    private snackbar: MatSnackBar,
    private dialogRef: MatDialogRef<ImportExcelComponent>,
    private dbService: DbService,
    private studentManagementService: StudentManagementService,
    private changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.isClass = data?.isClass ?? false;
  }

  openFileInput() {
    document.getElementById('fileInput')?.click();
  }

  onFileSelect(event: any) {
    const file = event.target.files[0];
    if (file && this.isExcelFile(file)) {
        this.selectedFile = file;
        this.isValidFile = true;
        this.uploadComplete = false;
        this.uploadResult = null;
    } else {
        this.selectedFile = null;
        this.isValidFile = false;
        if (event.target.files.length === 0) {
        } else {
            this.snackbar.open('Please select a valid Excel file (xlsx, xls, csv).', 'Close', { duration: 5000 });
        }
    }
}

onDragOver(event: DragEvent) {
  event.preventDefault();
}

  previewFile() {
    if (!this.selectedFile) return;
    
    const fileURL = URL.createObjectURL(this.selectedFile);
    
    window.open(fileURL, '_blank');
    
  }
  removeFile(): void {
    this.selectedFile = null;
    this.uploadProgress = 0;
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
        fileInput.value = '';
    }
}
onFileDrop(event: DragEvent) {
  event.preventDefault();
  const files = event.dataTransfer?.files;
  
  if (!files || files.length === 0) return;
  
  if (files.length > 1) {
      this.snackbar.open('Only single file upload is supported. Please drop one file at a time.', 'Close', { 
          duration: 5000, 
      });
      return;
  }
  if (this.selectedFile) {
      this.snackbar.open('Only one file is supported. Please remove the current file first.', 'Close', { 
          duration: 5000, 
      });
      return;
  }
  
  if (this.isExcelFile(files[0])) {
      this.selectedFile = files[0];
      this.isValidFile = true;
      this.uploadComplete = false;
      this.uploadResult = null;
  } else {
      this.snackbar.open('Only Excel files are allowed (xlsx, xls, csv).', 'Close', { duration: 5000 });
  }
}
  formatFileSize(bytes: number | undefined): string {
    if (typeof bytes !== 'number' || bytes < 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  private isExcelFile(file: File): boolean {
    const allowedTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 
      'application/vnd.ms-excel', 
      'text/csv'
    ];
    return allowedTypes.includes(file.type);
  }

  // importAttendance() {
  //   if (!this.selectedFile) {
  //     this.snackbar.open('Please select a file first.', 'Close', { duration: 5000 });
  //     return;
  //   }
  
  //   const businessId = this.dbService.getBusinessId();
  //   if (!businessId) {
  //     this.snackbar.open('Business ID is required', 'Close', { duration: 5000 });
  //     return;
  //   }
  
  //   this.isUploading = true;
  //   this.uploadProgress = 0;
  
  //   const payload = {
  //     file: this.selectedFile,
  //     businessId: businessId,
  //     isClass: this.isClass
  //   };
  
  //   this.studentManagementService.uploadAttendanceFile(payload).subscribe({
  //     next: (event) => {
  //       if (event.type === HttpEventType.UploadProgress && event.total) {
  //         this.uploadProgress = Math.round((event.loaded / event.total) * 100);
  //         this.changeDetectorRef.detectChanges();
  //       } else if (event.type === HttpEventType.Response) {
  //         this.uploadResult = event.body;
  //         this.isUploading = false;
  //         this.uploadComplete = true;
  //         this.snackbar.open('File uploaded successfully!', 'Close', { duration: 5000 });
  //       }
  //     },
  //     error: (error) => {
  //       this.handleUploadError(error.message || 'Upload failed');
  //     }
  //   });
  // }
//   importAttendance() {
//   if (!this.selectedFile) {
//     this.snackbar.open('Please select a file first.', 'Close', { duration: 5000 });
//     return;
//   }

//   this.isUploading = true;
//   this.uploadProgress = 0;

//   // this.studentManagementService.uploadStudentAttendance(this.selectedFile).subscribe({
//   //   next: (event) => {
//   //     if (event.type === HttpEventType.UploadProgress && event.total) {
//   //       this.uploadProgress = Math.round((event.loaded / event.total) * 100);
//   //       this.changeDetectorRef.detectChanges();
//   //     } else if (event.type === HttpEventType.Response) {
//   //       this.uploadResult = event.body;
//   //       this.isUploading = false;
//   //       this.uploadComplete = true;
//   //       debugger;
//   //       this.snackbar.open('File uploaded successfully!', 'Close', { duration: 5000 });
//   //     }
//   //   },
//   //   error: (error) => {
//   //     this.handleUploadError(error.message || 'Upload failed');
//   //   }
//   // });
//   //  const file = this.selectedFile.srcElement.files[0];
//    var formData = new FormData();
//   //    formData.append('file', this.selectedFile);
//   // formData.append('businessId', businessId);
//   // formData.append('isClass', this.isClass.toString());
//     formData.append('file', this.selectedFile);
//     this.studentManagementService.uploadStudentAttendance(formData).subscribe((res: any) => {
//     this.snackbar.open('Uploaded successfully', 'close', {duration: 2000});
//           document.getElementById('closeUploadExcel')?.click()
//       this.isUploading = false;
//     },
//     () => {
//       // this.handleUploadError(error.message || 'Upload failed');
//         this.snackbar.open('Some error occurred please try again', 'close', {duration: 2000});
//       this.isUploading = false;
//     }
//     )
// }
// importAttendance() {
//   if (!this.selectedFile) {
//     this.snackbar.open('Please select a file first.', 'Close', { duration: 5000 });
//     return;
//   }

//   this.isUploading = true;
//   this.uploadProgress = 0;

//   const formData = new FormData();
//   formData.append('file', this.selectedFile);
//   this.studentManagementService.uploadStudentAttendance(formData).subscribe({
//     next: (event) => {
//       if (event.type === HttpEventType.UploadProgress && event.total) {
//         this.uploadProgress = Math.round((event.loaded / event.total) * 100);
//         this.changeDetectorRef.detectChanges();
//       } else if (event.type === HttpEventType.Response) {
//         this.snackbar.open('Uploaded successfully', 'close', { duration: 2000 });
//         document.getElementById('closeUploadExcel')?.click();
//         this.isUploading = false;
//         this.uploadComplete = true;
//       }
//     },
//     error: () => {
//       this.snackbar.open('Some error occurred, please try again', 'close', { duration: 2000 });
//       this.isUploading = false;
//     }
//   });
// }
importAttendance() {
  if (!this.selectedFile) {
    this.snackbar.open('Please select a file first.', 'Close', { duration: 5000 });
    return;
  }

  this.isUploading = true;

  const formData = new FormData();
  formData.append('file', this.selectedFile);

  this.studentManagementService.uploadStudentAttendance(formData).subscribe({
    next: (res) => {
      this.snackbar.open('Uploaded successfully', 'close', { duration: 2000 });
      document.getElementById('closeUploadExcel')?.click();
      this.isUploading = false;
      this.uploadComplete = true;
    },
    error: (err) => {
      console.error('Upload error:', err);
      this.snackbar.open('Some error occurred, please try again', 'close', { duration: 2000 });
      this.isUploading = false;
    }
  });
}


  closeBtn() {
    this.dialogRef.close({
        success: this.uploadComplete,
        isClass: this.isClass
    });
}

  private handleUploadError(error: string) {
    // console.error('Upload error:', error);
    this.isUploading = false;
    this.uploadProgress = 0;
    this.snackbar.open('Upload failed. Please try again.', 'Close', { duration: 5000 });
    this.changeDetectorRef.detectChanges();
  }
}